module.exports = __webpack_public_path__ + "img/in.16fcb0a6.svg";